const SKIP_SELECTORS = [':popover-open', '[data-user-edited]'];

function shouldSkip(node) {
  if (!(node instanceof Element)) return false;
  if (node === document.activeElement) return true;
  for (const sel of SKIP_SELECTORS) {
    try {
      if (node.matches(sel)) return true;
    } catch {
    }
  }
  return false;
}

function getKey(node) {
  if (!(node instanceof Element)) return null;
  return node.id || node.getAttribute('data-key');
}

function copyAttributes(target, source) {
  for (const { name } of [...target.attributes]) {
    if (!source.hasAttribute(name)) target.removeAttribute(name);
  }
  for (const { name, value } of source.attributes) {
    if (target.getAttribute(name) !== value) target.setAttribute(name, value);
  }
}

function morphChildren(target, source) {
  const targetChildren = [...target.childNodes];
  const sourceChildren = [...source.childNodes];

  const targetByKey = new Map();
  for (const child of targetChildren) {
    const key = getKey(child);
    if (key) targetByKey.set(key, child);
  }

  for (let i = 0; i < sourceChildren.length; i++) {
    const newChild = sourceChildren[i];
    const newKey = getKey(newChild);
    let oldChild = newKey ? targetByKey.get(newKey) : targetChildren[i];

    if (!oldChild) {
      target.appendChild(newChild.cloneNode(true));
      continue;
    }

    if (shouldSkip(oldChild)) continue;

    if (oldChild.nodeType !== newChild.nodeType || oldChild.nodeName !== newChild.nodeName) {
      oldChild.replaceWith(newChild.cloneNode(true));
      continue;
    }

    if (oldChild.nodeType === Node.TEXT_NODE) {
      if (oldChild.nodeValue !== newChild.nodeValue) oldChild.nodeValue = newChild.nodeValue;
      continue;
    }

    if (oldChild instanceof Element && newChild instanceof Element) {
      copyAttributes(oldChild, newChild);
      morphChildren(oldChild, newChild);
    }

    if (newKey) targetByKey.delete(newKey);
  }

  for (const [, leftover] of targetByKey) {
    if (!shouldSkip(leftover)) {
      leftover.remove();
    }
  }

  while (target.childNodes.length > sourceChildren.length) {
    const last = target.lastChild;
    if (last && shouldSkip(last)) break;
    target.removeChild(last);
  }
}

export function morph(targetEl, sourceHtmlOrEl) {
  if (!targetEl) throw new Error('morph: target required');
  let sourceEl;
  if (typeof sourceHtmlOrEl === 'string') {
    const doc = new DOMParser().parseFromString(sourceHtmlOrEl, 'text/html');
    sourceEl = doc.body.firstElementChild;
  } else {
    sourceEl = sourceHtmlOrEl;
  }
  if (!sourceEl) throw new Error('morph: source HTML did not parse');

  if (targetEl.tagName !== sourceEl.tagName) {
    targetEl.replaceWith(sourceEl);
    return sourceEl;
  }
  copyAttributes(targetEl, sourceEl);
  morphChildren(targetEl, sourceEl);
  return targetEl;
}

export function morphSafe(targetEl, sourceHtmlOrEl) {
  try {
    return morph(targetEl, sourceHtmlOrEl);
  } catch (err) {
    console.error('[morph] fallback to innerHTML:', err);
    if (typeof sourceHtmlOrEl === 'string') {
      targetEl.outerHTML = sourceHtmlOrEl;
    } else {
      targetEl.replaceWith(sourceHtmlOrEl);
    }
    return targetEl;
  }
}
